// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3tbPP","logo":"header_logo__DNxqY","logoutBtn":"header_logoutBtn__3asrq"};